import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { selectIsLoading } from '@selectors'

import useStyles from './action-button.style'

import { IconInline, Paragraph, Title } from '@omnilert/components'

import BaseActionButton from '../base-action-button/base-action-button.component'

const ActionButton = props => {
  const { data, documentId, pill } = props

  const {
    icon,
    id,
    text,
    title
  } = data

  const loading = useSelector(selectIsLoading)

  const isLoading = loading.some(({ meta }) => id === meta?.actionId)

  const pillIsLoading = isLoading && pill

  const isMaxPillLength = pill && title.length > 25
  
  const classes = useStyles({ isLoading, isMaxPillLength, pillIsLoading })

  const iconName = () => {
    if (isLoading) return 'spinner'

    return icon
  }

  return (
    <BaseActionButton
      backgroundColor='transparent'
      className={classes.button}
      data={data}
      documentId={documentId}
      pill={pill}
    >
      {iconName() &&
        <IconInline
          className={classes.icon}
          name={iconName()}
          rotate={0}
          size={22}
        />}
      <div className={classes.contentWrapper}>
        {title &&
          <Title
            className={classes.title}
            color='var(--card--text__color)'
            size='xs'
          >
            {title}
          </Title>}
        {text &&
          <Paragraph
            className={classes.text}
            color='var(--card--text__color)'
            size='xs'
          >
            {text}
            
          </Paragraph>}
      </div>
    </BaseActionButton>
  )
}

ActionButton.defaultProps = {
  className: '',
  data: null,
  onClick: () => {}
}

ActionButton.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func
}

export default ActionButton
